<div class="header">
  <div class="header-inner">
    <div class="header-inner-top">
      <div class="flex-row flex-align-items-center">
        @if (logoUrl()) {
        <div class="logo-container">
          <img class="logo" [src]="logoUrl()" />
        </div>
        }
        <div class="nav-breadcrumbs">
          @for ( breadcrumb of navigationBreadcrumb?.breadcrumbs; track $index;
          let i = $index) {
          <mat-icon
            class="cursor-pointer"
            data-cy="back"
            (click)="redirect(breadcrumb?.route)"
            >keyboard_backspace</mat-icon
          >
          <div class="anchor" (click)="redirect(breadcrumb?.route)">
            {{ 'common.label.backTo' | translate }}
            {{ breadcrumb.text | truncate : 30 }}
          </div>
          } @if (navigationBreadcrumb?.currentPage) {
          <mat-icon class="rightarr">chevron_right</mat-icon>
          }
          <div class="last">
            {{ navigationBreadcrumb?.currentPage }}
          </div>
        </div>
      </div>
      <div class="breadcrumb-actions">
        @if(navigationBreadcrumb?.progressStepType){
        <qa-steps-progress-button
          [progressStepType]="navigationBreadcrumb?.progressStepType"
        ></qa-steps-progress-button>
        } @if(navigationBreadcrumb?.actions){ @for ( action of
        navigationBreadcrumb?.actions; track $index) {
        <qa-button
          [icon]="action?.icon"
          [isRoundedButton]="true"
          [label]="action?.label"
          (submitted)="onActionClick(action)"
        ></qa-button>
        } }
      </div>
    </div>
  </div>
</div>
